exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swell-card-title {\n  padding: 1.25rem 1.25rem 0 1.25rem;\n  margin-bottom: -10px;\n  font-weight: 300;\n  font-size: 20px;\n}\n", ""]);

// exports
